import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Save, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";

export default function MsConfigForm({ ms, onUpdated }) {
  const [email, setEmail] = useState(ms?.sync_email || "");
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [scanning, setScanning] = useState(false);

  const handleTest = async () => {
    setTesting(true); setTestResult(null);
    try {
      const r = await api.post("/email-sync/test");
      setTestResult(r.data);
      if (r.data.success) toast.success(`Connected to ${r.data.organization}`);
      else toast.error(r.data.error || "Connection failed");
    } catch (err) { setTestResult({ success: false, error: err.response?.data?.detail || "Failed" }); toast.error("Test failed"); }
    setTesting(false);
  };

  const handleSave = async () => {
    if (!email.includes("@")) { toast.error("Enter a valid email"); return; }
    setSaving(true);
    try {
      await api.post("/email-sync/configure", { sync_email: email });
      toast.success("Email sync configured");
      onUpdated?.();
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    setSaving(false);
  };

  const handleScanNow = async () => {
    setScanning(true);
    try {
      const r = await api.post("/email-sync/scan-now");
      if (r.data.success) {
        const s = r.data.stats || {};
        toast.success(`Scan complete: ${s.invoices || 0} invoices, ${s.quotes || 0} quotes, ${s.communications || 0} communications`);
        onUpdated?.();
      } else toast.error(r.data.error || "Scan failed");
    } catch (err) { toast.error(err.response?.data?.detail || "Scan failed"); }
    setScanning(false);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input data-testid="ms-sync-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Outlook mailbox to scan (e.g. info@supplyhouse.co.za)" className="rounded-sm border-gray-300 h-9 flex-1" disabled={!ms?.configured} />
        <Button size="sm" onClick={handleSave} disabled={saving || !ms?.configured} className="bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm h-9">
          {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5 mr-1" />} Save
        </Button>
      </div>
      <div className="flex items-center gap-2">
        <Button data-testid="ms-test-btn" size="sm" variant="outline" onClick={handleTest} disabled={testing || !ms?.configured} className="rounded-sm h-8 text-xs">
          {testing ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Mail className="w-3 h-3 mr-1" />} Test Connection
        </Button>
        <Button data-testid="ms-scan-btn" size="sm" variant="outline" onClick={handleScanNow} disabled={scanning || !ms?.configured || !ms?.sync_email} className="rounded-sm h-8 text-xs">
          {scanning ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <RefreshCw className="w-3 h-3 mr-1" />} Scan Now
        </Button>
        {testResult && <span className={`text-xs ${testResult.success ? "text-green-600" : "text-red-500"}`}>{testResult.success ? `Connected: ${testResult.organization}` : testResult.error}</span>}
      </div>
    </div>
  );
}
